export const getLabels = () => ({
  certifiedOperator: "Certified operator",
  confirm: "Confirm",
  cancel: "Cancel",
  emailInvalid: "Email is invalid",
  emailRequired: "Email is required",
  formNotValid: "Form is not valid",
  loading: "Loading...",
  certificationDescription: "To link your certificate, enter the email and the unique ID sent to you.",
  createdFailed: "Sorry, the registration was unsuccessful.",
  createdSuccess: "Certificate linked successfully",
  enableCertifiedOperator: "Register Certificate",
  idAlreadyExists: "Operation failed: ID already registered.",
  idCertificationPlaceholder: "Installer code",
  idCertificationRequired: "Installer code is required",
  registerFailed: "Certification registration failed",
  registerIDCertification: "Register installer code",
  registerIDCertificationDescription: "You are registering your certification.",
  registerSuccessfully: "Certification registered successfully",
});

export const labels = getLabels();
